interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  return (
    <nav className="flex items-center justify-center gap-2 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700 cursor-pointer disabled:cursor-not-allowed whitespace-nowrap"
      >
        上一页
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`w-9 h-9 rounded-md text-sm cursor-pointer transition-colors ${
            p === page
              ? "bg-primary-500 text-background-50 font-semibold"
              : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700 cursor-pointer disabled:cursor-not-allowed whitespace-nowrap"
      >
        下一页
      </button>
    </nav>
  );
}